import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import Grid from "material-ui-next/Grid";
import { SaleStatus, AcquirerNames, NetworkNames } from "core/enum";
import _ from "lodash";
import {
  Page,
  Loadable,
  DataTable,
  ViewSaleButton,
  Fab,
  If,
  CardValue,
  CurrencyValue,
  InfoTooltip
} from "components/support";
import { colors, Icon } from "assets";
import Filter from "./filter";
import SummaryCard from "./summary-card";
import ReportEmail from "./report-email";
import { PaymentTypes } from "core/enum";

class PaymentsReportView extends Component {
  config = {
    identifier: "id",
    columns: [
      {
        id: "processed_at",
        accessor: "processed_at",
        Header: "Data",
        type: "datetime",
        align: "center"
      },
      {
        id: "real_amount",
        Header: "Total",
        type: "custom",
        align: "right",
        Cell: props => (
          <CurrencyValue value={props.original.real_amount} type="money" />
        )
      },
      {
        id: "receipt",
        Header: "Venda",
        type: "custom",
        align: "center",
        Cell: props => {
          const sale = props.original.sale;
          return (
            sale && (
              <ViewSaleButton
                sale={{
                  uuid: props.original.sale_uuid,
                  document: {
                    type: sale.type,
                    number: sale.number
                  }
                }}
              />
            )
          );
        },
        sortable: false
      },
      {
        id: "status",
        Header: "Status da Venda",
        type: "enum",
        align: "center",
        accessor: "sale.status",
        params: { enum: SaleStatus },
        sortable: false
      },
      {
        id: "type",
        Header: "Pagamento",
        type: "custom",
        align: "center",
        Cell: props =>
          props.original.metadata.other_payment_uuid
            ? this.parseCustomOtherPayment(
                props.original.metadata.other_payment_uuid
              )
            : this.getPaymentType(props.original),
        sortable: false
      },
      {
        accessor: "metadata.installments",
        Header: "Parcelas",
        align: "center"
      },
      {
        accessor: "metadata.network",
        Header: "Bandeira",
        align: "center",
        type: "enum",
        params: { enum: NetworkNames }
      },
      {
        accessor: "metadata.acquirer_name",
        Header: "Credenciadora",
        align: "center",
        type: "enum",
        params: { enum: AcquirerNames }
      },
      {
        accessor: "metadata.acquirer_authorization_number",
        Header: "NSU",
        align: "center"
      }
    ]
  };

  downloadButton = () => (
    <Fab
      backgroundColor={colors.button.secondary}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.props.presenter.onDownload("csv"),
          iconComponent: (
            <Icon.CsvFile style={{ fill: colors.secondary.dark }} />
          ),
          tooltip: "CSV"
        }
        /*
        {
          backgroundColor: colors.primary.normal,
          onClick: () => this.handleDownloadButton('pdf'),
          icon: icons.svg.pdfFile,
          tooltip: 'PDF'
        },
        */
      ]}
    />
  );

  parseCustomOtherPayment = uuid => {
    const otherPayment = this.props.viewModel.summary.find(
      other => other.custom_payment === uuid
    );
    const label = otherPayment ? otherPayment.payment_label : "";
    return label;
  };

  getPaymentType({ type, metadata }) {
    if (type !== "credit_card") {
      return PaymentTypes[type];
    }
    const installments = metadata.installments > 1 ? "installments" : type;
    return PaymentTypes[installments];
  }

  getSelectedClass(item, filters) {
    if (!filters.customType && !filters.paymentType) {
      return null;
    }

    if (!_.isNull(filters.in_cash) && item.in_cash !== filters.in_cash) {
      return "summary-non-selected";
    }

    if (item.payment_type === filters.paymentType) {
      if (filters.customType) {
        if (
          !item.custom_payment ||
          filters.customType !== item.custom_payment
        ) {
          return "summary-non-selected";
        }
      }

      if (!filters.customType && item.custom_payment) {
        return "summary-non-selected";
      }

      return null;
    }

    return "summary-non-selected";
  }

  render() {
    const { presenter, viewModel } = this.props;
    const {
      loading,
      filters,
      revenues,
      summary,
      results,
      pagination,
      order,
      emailLoading
    } = viewModel;
    return (
      <Page>
        <Loadable loading={loading}>
          <Row>
            <Col xs>
              <Typography type="display1" className="pb-sm">
                Relatório de Pagamentos
              </Typography>
            </Col>
            <Col>
              <ReportEmail
                loading={emailLoading}
                onSendEmailReport={email => presenter.onSendEmailReport(email)}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md>
              <Filter
                className="full-height"
                loading={loading}
                filters={filters}
                onChange={filters => presenter.onFilterChange(filters)}
              />
            </Col>
            <If test={!_.isEmpty(revenues)}>
              <Col
                style={styleSummaryItem}
                xs={12}
                md={4}
                onClick={() =>
                  presenter.onSelectType(
                    revenues.payment_type,
                    revenues.custom_payment
                  )
                }
              >
                <div className="pb-md full-height full-width text-center">
                  <Paper elevation={3} className="full-height">
                    <Grid
                      container
                      alignItems="center"
                      justify="center"
                      spacing={0}
                      className="full-height"
                    >
                      <Grid item>
                        <Typography type="headline">
                          Faturamento Total
                          <InfoTooltip hint="Inclui faturamento dos opcionais." />
                        </Typography>
                        <CardValue positive={revenues.total_value > 0}>
                          <CurrencyValue
                            value={revenues.total_value}
                            type="money"
                          />
                        </CardValue>
                      </Grid>
                    </Grid>
                  </Paper>
                </div>
              </Col>
            </If>
          </Row>
          <Row>
            {summary.map(item => {
              if (item.payment_label === "Faturamento") {
                return null;
              }
              return (
                <Col
                  style={styleSummaryItem}
                  xs={12}
                  sm={6}
                  md={4}
                  key={item.payment_label}
                  onClick={() =>
                    presenter.onSelectType(
                      item.payment_type,
                      item.custom_payment,
                      item.in_cash
                    )
                  }
                  className={this.getSelectedClass(item, filters)}
                >
                  <SummaryCard
                    tooltip={item.custom_payment ? "Pagamento Personalizado" : false }
                    revenues={revenues.total_value}
                    label={item.payment_label}
                    value={item.total_value}
                  />
                </Col>
              );
            })}
          </Row>
          <Row>
            <Col xs={12}>
              <Paper elevation={1}>
                <DataTable
                  manual
                  defaultSorted={[{ id: "processed_at", desc: true }]}
                  filterable={false}
                  resultSet={results}
                  total={pagination.total}
                  perPage={pagination.perPage}
                  page={pagination.page}
                  config={this.config}
                  onChange={({ field, value }) =>
                    presenter.onOrderChange(field, value)
                  }
                  orderField={order.field}
                  orderDirection={order.direction}
                  onPageChange={page => presenter.onPageChange(page + 1)}
                />
              </Paper>
            </Col>
          </Row>

          {this.downloadButton()}
        </Loadable>
      </Page>
    );
  }
}

const styleSummaryItem = {
  cursor: "pointer"
};

export default PaymentsReportView;



// WEBPACK FOOTER //
// ./src/components/app/management/payments-report/payments-report.view.jsx